import firebase from '../../firebase';
//import { resolve } from 'path';

// initial state
const state = {
  allProducts: [],
  product: null,
  packagesProduct: []
}


// getters
const getters = {
  allProducts: state => state.allProducts,
  product: state => state.product,
  packagesProduct: state => state.packagesProduct
}

// mutations
const mutations = {
  setProducts(state, products) {
    state.allProducts = products
  },
  setProduct(state, product) {
    console.log("setProduct", product)
    state.product = product
  },
  setPackagesProduct(state, packages) {
    state.packagesProduct = packages
  }
}

// actions
const actions = {
  getAllProducts: function ({ commit }) {
    var products = [];
    firebase.database.ref("products").on("value", function (snapshot) {
      snapshot.forEach(function (item) {
        var itemVal = item.val();
        products.push({ id: item.key, name: itemVal.productname, type: itemVal.producttype });
      })
      commit('setProducts', products);
    })
  },
  getProductById: function ({ commit }, data) {
    return new Promise((resolve, reject) => {
      firebase.database.ref('products').child(data.id).once("value", function (snapshot) {
        let product = snapshot.val();
        product.id = data.id;
        product.source = data.source;

        // Override appealid and fundid
        // Suspected use only with Paypal after payment
        if (data.appealid) {
          product.appealcodesetting.appealid = data.appealid;
        }
        if (data.fundid) {
          product.appealcodesetting.fundid = data.fundid;
        }

        // Map the old structure to the new one
        // Need to populate the donationsettings object
        if (product) {

          const keys = product.donationsettings ? Object.keys(product.donationsettings) : [];

          // Only map to the new structure if the structure is empty
          if (keys.length === 0) {
            product.donationsettings = {};

            if (product.donationtypes.length > 0) {
              for (const type of product.donationtypes) {
                product.donationsettings[type] = {
                  campaignid: product.appealcodesetting.campaignid,
                  fundid: product.appealcodesetting.fundid
                };
              }

              // Set the defaultdonationtype as the first of the array
              // Always take the first one in alphabetical order
              // In FormProduct, the default donation type is the first of this array. Just following the same structure.
              const defualtType = product.donationtypes[0];
              product.appealcodesetting.defaultdonationtype = defualtType;
              product.appealcodesetting.campaignid = product.donationsettings[defualtType].campaignid;
              product.appealcodesetting.fundid = product.donationsettings[defualtType].fundid;
            }
          }
        }

        commit('setProduct', product)
        resolve();

      }, function (error) {
        console.log("getProductById error", error)
        reject(error)
      })
    })
  },
  getProductByIds: function (context, ids, rootState) {
    var products = [];
    return new Promise((resolve, reject) => {
      if (ids) {
        var promises = [];
        for (var i = 0; i < ids.length; ++i) {
          var promise = firebase.database.ref('products').child(ids[i]).once("value", function (snapshot) {
            products.push(snapshot.val());
          }, function (error) {
            // The Promise was rejected.
            console.log("getProductById error", error)
          });

          promises.push(promise);
        }

        Promise.all(promises).then(
          response => {
            resolve(products);
          },
          error => {
            console.error("getProductById error", error);
          }
        );

      }
    })

  },
  getAllPackagesForProduct: async function ({ dispatch, state, commit }) {
    var packages = [];

    //todo refactor
    async function asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array)
      }
    }

    const start = async () => {
      await asyncForEach(state.product.packages, async (id) => {
        dispatch('getPackagesById', id).then(function (value) {
          packages.push(value)
        });
      })
      commit('setPackagesProduct', packages);
    }

    if (state.product.packages && state.product.packages.length > 0) {
      return start()
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/products.js